(function () {
    'use strict';

    function PersonInfoComponentV2Controller($scope, $state, PersonInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, SelectorData, SelectorDataQuery) {
        //

        var $ctrl = this;
        var pagingParams = {};
        $ctrl.gender;
        $ctrl.loadPage = loadPage;
        $ctrl.necessaryFieldsCheck = necessaryFieldsCheck;
        $ctrl.selectedId = '';
        $ctrl.provinceList = [];
        $ctrl.cityList = [];

        loadAll();
        loadPage();

        function loadAll() {

            if ($ctrl.showImage == undefined)
                $ctrl.showImage = true;

            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function necessaryFieldsCheck() {

            try {
                if (($ctrl.personInfo.fisrtName != '' && $ctrl.personInfo.fisrtName != undefined) &&
                    ($ctrl.personInfo.lastName != '' && $ctrl.personInfo.lastName != undefined)) {
                    // $scope.$parent.vm.hasAllNecessaryFields = true;
                    $ctrl.canSave = true;
                } else {
                    // $scope.$parent.vm.hasAllNecessaryFields = false;
                    $ctrl.canSave = false;
                }
            } catch (ex) {
                // nothing
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('personInfo');
            translatePartialLoader.addPart('locationInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('servant');
            translatePartialLoader = translate.refresh();

            if ($ctrl.userAccountId) {
                $ctrl.blockedEdit = true;
            } else {
                $ctrl.blockedEdit = false;
            }

            if ($ctrl.personInfo != undefined && $ctrl.personInfo.location != undefined && $ctrl.personInfo.location.countryId != null && $ctrl.personInfo.location.countryId != undefined) {
                $ctrl.provinceList = SelectorDataQuery.findByTypeAndParent('province', $ctrl.personInfo.location.countryId).query();
                if ($ctrl.personInfo.location.stateId != null && $ctrl.personInfo.location.stateId != undefined) {
                    $ctrl.cityList = SelectorDataQuery.findByTypeAndParent('city', $ctrl.personInfo.location.stateId).query();
                }

            }

            if ($ctrl.blockEditPhoneNumber == null || $ctrl.blockEditPhoneNumber == undefined)
                $ctrl.blockEditPhoneNumber = false;

            if ($ctrl.personInfo && $ctrl.personInfo)
                $ctrl.necessaryFieldsCheck();

        }

        function country_changed() {
            $ctrl.provinceList = SelectorDataQuery.findByTypeAndParent('province', $ctrl.personInfo.location.countryId).query();
        }

        function province_changed() {
            $ctrl.cityList = SelectorDataQuery.findByTypeAndParent('city', $ctrl.personInfo.location.stateId).query();
        }

    }

    var PersonInfoComponentV2 = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/person-info-v2/partial-form.person-info-v2.html',
        controller: PersonInfoComponentV2Controller,
        bindings:
            {
                personInfo: '=',
                servantCode: '=',
                userAccountId: '=',
                isCustomer: '=',
                isServant: '=',
                blockEditPhoneNumber: '=?',
                canSave: '=?',
                showImage: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('pfPersonInfoV2', PersonInfoComponentV2)

    PersonInfoComponentV2Controller.$inject = ['$scope', '$state', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'SelectorData', 'SelectorDataQuery'];


})();

